// Qué le falta al perfil para poder usar todo: el domicilio (teletrabajo) y,
// si la empresa emite certificados CAE, el DNI. Lo usan el aviso "Completa
// tu perfil" y el punto en la pestaña Perfil de las barras de navegación.
export const profileMissing = (user) => ({
  home: !!user && !user.home_lat,
  dni: !!user && !!user.company_is_cae_enabled && !user.has_dni && !user.dni_nif && user.role !== "super_admin",
});

export const isProfileIncomplete = (user) => {
  const m = profileMissing(user);
  return m.home || m.dni;
};
